// import tracer from "@/utils/stat";

export const stat = {
  bind(el, binding) {
    el.addEventListener(
      "click",
      () => {
        const data = binding.value;
        // console.log(222, el, data);
        // tracer.stash(data);
      },
      false
    );
  }
};
